export const FlagTypeOptions = [
    { value: 1, label: 'Staffing Issue' },
    { value: 2, label: 'Equipment Issue' },
    { value: 3, label: 'Customer Issue' },
    { value: 4, label: 'Scheduling Conflict' },
    { value: 5, label: 'Safety Concern' },
    { value: 6, label: 'Other' },
];

export const OtherFlagTypeId = 6;
